module.exports = function(state = {}, action) {
  switch (action.type) {
    case "SET_STATE":
      return Object.assign({}, action.state)
    default:
      return state;
  }
}
